// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";

import FilterGroup from '../../components/Analytics/FilterGroup'
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const lastDashboardDataRequestURL = endpointHelias+'/Helias/V0/General/lastDashboardData';	

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var analyticsCommonJS = require("../../js/analyticsCommon.js");

var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var fechaActual = (new Date(Date.now() - tzoffset)).toISOString().split("T")[0];     

// Función del router
const AnalyticsFilters = (params) => {

  const [objGroupsData, setObjGroupsData] = useState({
    "GeneralData": [],
    "MeteoData": [],
    "InstallationData": [],
    "FVData": [],
    "BatteriesData": [],
    "GeneratorData": [],
    "CarsData": [],
    "SelfConsumptionAndSavingsData": [],
  })

  useEffect(() => {   
      console.log("Componente filtros de analytics cargado correctamente.")
      cargarFiltros()   
      
        
      
  }, [params.objQueryGrafica]);

  function cargarFiltros(){   

    var jsonRespuesta = ""

    if(localStorage.getItem("lastDashboardData") === null){

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
            
      //Petición de datos para el paso actual      
      var jsonPeticion = ""
  
      if(localStorage.getItem("activeUserInstallation") !== null){
        jsonPeticion = {
          "accountID": localStorage.getItem("accountID"), //REVISAR ESTE ACCOUNT EN INSTALADOR
          "installationID": localStorage.getItem("activeUserInstallation")
        }
      }
      else{
        jsonPeticion = {
          "accountID": localStorage.getItem("accountID"),
          "installationID": localStorage.getItem("installationId") 
        }
      }

      // Guardo la información  
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", lastDashboardDataRequestURL, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {
            jsonRespuesta = JSON.parse(this.responseText)
    
            if(jsonRespuesta.statusCode === "403"){                           
              initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }                
            else{                          
              //Si no hay datos configurados entonces no hago nada  
              jsonRespuesta = JSON.parse(this.responseText).body
              console.log("Filtros de analytics cargados correctamente.")
            }
          }
      
          if (this.readyState === 4 && this.status !== 200) {      
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
          }
      }
      
      xhttp.send(data);             
    }
    else{ //Tengo datos del dashboard

      //jsonRespuesta = JSON.parse(this.responseText)
      jsonRespuesta = JSON.parse(localStorage.getItem("lastDashboardData"))

    }

    if(typeof jsonRespuesta !== 'undefined'){

      if(jsonRespuesta.InstallationData !== undefined){

        //En caso de ser un instalador guardo la info del dashboard actual
        if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
          localStorage.setItem("lastDashboardData", JSON.stringify(jsonRespuesta))
        }
        
        var objGroupsDataTemp = {
          "GeneralData": [],
          "MeteoData": [],
          "InstallationData": [],
          "FVData": [],
          "BatteriesData": [],
          "GeneratorData": [],
          "CarsData": [],
          "SelfConsumptionAndSavingsData": []
        }
      
        if(jsonRespuesta.InstallationData.GeneralInfo.MainElectricConnectionSensorsInInstallation === "true"){
          objGroupsDataTemp = generarListaFiltrosGrupo("GeneralData", "", jsonRespuesta.GeneralData, objGroupsDataTemp)
          objGroupsDataTemp = generarListaFiltrosGrupo("MeteoData", "", jsonRespuesta.MeteoData, objGroupsDataTemp)
          objGroupsDataTemp = generarListaFiltrosGrupo("InstallationData", "", jsonRespuesta.InstallationData.GeneralInfo, objGroupsDataTemp)                
          objGroupsDataTemp = generarListaFiltrosGrupo("FVData", jsonRespuesta.InstallationData.GeneralInfo, jsonRespuesta.FVData, objGroupsDataTemp)                
          objGroupsDataTemp = generarListaFiltrosGrupo("BatteriesData", "", jsonRespuesta.BatteriesData, objGroupsDataTemp)
          objGroupsDataTemp = generarListaFiltrosGrupo("GeneratorData", "", jsonRespuesta.GeneratorData, objGroupsDataTemp)
          objGroupsDataTemp = generarListaFiltrosGrupo("CarsData", "", jsonRespuesta.CarsData[0], objGroupsDataTemp)
          objGroupsDataTemp = generarListaFiltrosGrupo("SelfConsumptionAndSavingsData", "", jsonRespuesta.SelfConsumptionAndSavingsData, objGroupsDataTemp)
        }
        else{ //Usuario básico sin monitor de consumo
          objGroupsDataTemp = generarListaFiltrosGrupo("MeteoData", "", jsonRespuesta.MeteoData, objGroupsDataTemp)
        }                

        setObjGroupsData(objGroupsDataTemp)        
      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Esta instalación tiene problemas técnicos o de conectividad. Avise al propietario o proceda a su revisión in-situ.","negative")
        
      }

    }  

  }    

  function generarListaFiltrosGrupo(nombreGrupo, InstallationData, objGrupo, objListaFinal){

    var filtrosBlacklist = ['DashboardTimerRefresh','AppliancesVerified','InstallationType','EnergyGridConnected','CityName','MunicipalityId','QueryUpdateTime','Forecasting',
    'AEMETUpdateTime','ProvinceName','NowForcasting','InstallationLongitude','InstallationLatitude','FVMaxGeneration','FVType','BatteriesInverterMaxPower',
    'BatteriesMaxCapacity','GeneratorOnOffSwitch','GeneratorMaxGeneration','GeneratorTankCapacity','MaximumChargeAmperage','CarName','UpdateTime','DynamicChargeStatus','TelegramAccount','GeneralGridSwitch',
    'Sunrise','Sunset','ElectricSystemType','MainElectricConnectionSensorsInInstallation','FVMaxGenerationEstimationMode','RemainingBatteryChargeTime','RemainingBatteryDischargeTime',
    'CombustiblePrice','CarID',"CurrentMonthlastUpdate","SinceRegistrationlastUpdate","TodaylastUpdate","YearlastUpdate","GeneratorType","BillDiscount","DailyEnergyBuyPrice","SolarWallet",
    'TodayDiscountValue','TodayFixedPayments','TodayTotalReactive','CurrentMonthDiscountValue','CurrentMonthFixedPayments','CurrentMonthTotalReactive','YearDiscountValue','YearFixedPayments','YearTotalReactive',
    'SinceRegistrationDiscountValue','SinceRegistrationFixedPayments','SinceRegistrationTotalReactive','PowerExcessesLastOcurrence','SolarWalletActivationDate','FVSubsidy','SolarWalletFree','BillingStartDate',
    'FVStatus','MaxPowerContracted','RulesConfigured','Application','ChargesInInstallation','TodayfromGridPerTimeframe','CurrentMonthfromGridPerTimeframe','YearfromGridPerTimeframe','SinceRegistrationfromGridPerTimeframe',
    'TodayPowerExcessesPenalty','CurrentMonthPowerExcessesPenalty','YearPowerExcessesPenalty','SinceRegistrationPowerExcessesPenalty','TodayEnergeticUse','CurrentMonthEnergeticUse','YearEnergeticUse','SinceRegistrationEnergeticUse',
    'TodayPercentageReactive','CurrentMonthPercentageReactive','YearPercentageReactive','SinceRegistrationPercentageReactive','CurrentMonthPowerExcessesCount','YearPowerExcessesCount','SinceRegistrationPowerExcessesCount',
    'CurrentMonthReactivePenaltyAmount', 'YearReactivePenaltyAmount', 'SinceRegistrationReactivePenaltyAmount','TotalReactiveEnergy','TodayTotalGeneration','CurrentMonthTotalGeneration','YearTotalGeneration','SinceRegistrationTotalGeneration',
    'Todayconsumption','CurrentMonthconsumption','Yearconsumption','SinceRegistrationconsumption','YearenergyRevenue','SinceRegistrationenergyRevenue','YearenergyWaste','SinceRegistrationenergyWaste','TodayfromGrid',
    'CurrentMonthfromGrid','YearfromGrid','SinceRegistrationfromGrid','TodaytoGrid','YeartoGrid','SinceRegistrationtoGrid','TodaysavingsBalance','YearsavingsBalance','SinceRegistrationsavingsBalance',
    'TodayselfConsumption','CurrentMonthselfConsumption','YearselfConsumption','SinceRegistrationselfConsumption','TodayselfConsumptionBalance','YearselfConsumptionBalance','SinceRegistrationselfConsumptionBalance',
    'CurrentMonthusedEnergyCost','YearusedEnergyCost','SinceRegistrationusedEnergyCost','HistoricalMaxPowerConsumption','PreviousMonthsSolarWalletBalance','CurrentMonthGeneratorLitersConsumed','CurrentMonthGeneratorConsumptionCost',
    'YearGeneratorLitersConsumed','YearGeneratorConsumptionCost','SinceRegistrationGeneratorLitersConsumed','SinceRegistrationGeneratorConsumptionCost','TodayGivenAwayMoney','CurrentMonthenergyRevenue','CurrentMonthenergyWaste',
    'CurrentMonthtoGrid','BatteriesCurrentCapacity','BatteryTemperature','BatteryStatus','CarLatitude','CarLongitude','ChargeLatchStatus','ChargeStatus','ChargeType','CurrentChargeLimit','RemainingChargeTime','CurrentGeneratorTankPercentage',
    'TodayGeneratorConsumptionCost','TodayGeneratorLitersConsumed','TodayusedEnergyCost','EnergyConfiguration','PowerConfiguration','TodayfromGridPerTimeframe','CurrentMonthfromGridPerTimeframe','YearfromGridPerTimeframe',
    'SinceRegistrationfromGridPerTimeframe',"LastBillingFeesCheck","BatteryId","CurrentBatteryWorkingMode","DynamicBatteriesNightCharge","TOUPermitsAccepted"]

    //Y añado algún filtrado más en algunos casos de instalación
    
    var jsonObjDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))

    //Instalación básica conectada a la red general
    if( (Object.keys(jsonObjDashboard.FVData).length === 0) && (Object.keys(jsonObjDashboard.BatteriesData).length === 0) && (Object.keys(jsonObjDashboard.GeneratorData).length === 0) ){
      filtrosBlacklist.push("TotalBulkGeneration")
      filtrosBlacklist.push("TotalWastedEnergy")
      filtrosBlacklist.push("GeneralWhInstallationConsumptionP1")
      filtrosBlacklist.push("GeneralWhInstallationGenerationP1")
      //filtrosBlacklist.push("GeneralWhInstallationTOTALGeneration")
      filtrosBlacklist.push("GeneralWhInstallationTOTALConsumption")
      filtrosBlacklist.push("GeneralWhInstallationTOTALWastedEnergy")
      filtrosBlacklist.push("GeneralWhInstallationWastedEnergyP1")
    }
    
    if(jsonObjDashboard.InstallationData.GeneralInfo.EnergyGridConnected === "false"){
      
      filtrosBlacklist.push("GeneralWhInstallationTOTALGeneration")      
      filtrosBlacklist.push("GeneralWhInstallationTOTALWastedEnergy")      
      filtrosBlacklist.push("BestBuyPrice")      
      filtrosBlacklist.push("BestSellPrice")      
      filtrosBlacklist.push("MarketAverageBuyPrice")      
      filtrosBlacklist.push("WorstBuyPrice")  
      filtrosBlacklist.push("WorstSellPrice")  
      filtrosBlacklist.push("EnergyBuyPrice")  
      filtrosBlacklist.push("DailyAverageBuyPrice")      
      filtrosBlacklist.push("DailyAverageSellPrice")
      filtrosBlacklist.push("PowerContracted")      
      
      filtrosBlacklist.push("EnergySellPrice")      
      filtrosBlacklist.push("DailyEnergySellPrice")      
      
      filtrosBlacklist.push("TodayPowerExcessesCount")            
      
      filtrosBlacklist.push("TodayGivenAwayMoney")      
      filtrosBlacklist.push("TodayenergyRevenue")
      filtrosBlacklist.push("TodayenergyWaste")              
      filtrosBlacklist.push("TodaytoGrid")
      filtrosBlacklist.push("TodayfromGrid")
      filtrosBlacklist.push("TodayPercentageReactive")
      

      filtrosBlacklist.push("CurrentMonthGivenAwayMoney")      
      filtrosBlacklist.push("CurrentMonthenergyRevenue")
      filtrosBlacklist.push("CurrentMonthenergyWaste")   
      filtrosBlacklist.push("CurrentMonthtoGrid")
      filtrosBlacklist.push("CurrentMonthfromGrid")
      filtrosBlacklist.push("CurrentMonthPercentageReactive")
  
      filtrosBlacklist.push("YearenergyRevenue")
      filtrosBlacklist.push("YearenergyWaste")   
      filtrosBlacklist.push("YeartoGrid")  
      filtrosBlacklist.push("YearfromGrid")
      filtrosBlacklist.push("YearPercentageReactive")

      filtrosBlacklist.push("SinceRegistrationenergyRevenue")
      filtrosBlacklist.push("SinceRegistrationenergyWaste")   
      filtrosBlacklist.push("SinceRegistrationtoGrid")
      filtrosBlacklist.push("SinceRegistrationfromGrid")
      filtrosBlacklist.push("SinceRegistrationPercentageReactive")

      filtrosBlacklist.push("CurrentMonthsavingsBalance")
      filtrosBlacklist.push("TodayReactivePenaltyAmount")

      filtrosBlacklist.push("CurrentMonthselfConsumptionBalance")      

    }
    
    if((Object.keys(jsonObjDashboard.FVData).length === 0)){
      filtrosBlacklist.push("TodayTotalGeneration")      
      filtrosBlacklist.push("TodayselfConsumption")
      filtrosBlacklist.push("TodayEnergeticUse")
      filtrosBlacklist.push("Todayconsumption")
      filtrosBlacklist.push("TodayusedEnergyCost")
      
      filtrosBlacklist.push("CurrentMonthTotalGeneration")
      filtrosBlacklist.push("CurrentMonthselfConsumption")      
      filtrosBlacklist.push("CurrentMonthEnergeticUse")
      filtrosBlacklist.push("CurrentMonthconsumption")
      filtrosBlacklist.push("CurrentMonthusedEnergyCost")

      filtrosBlacklist.push("YearTotalGeneration")
      filtrosBlacklist.push("YearselfConsumption")
      filtrosBlacklist.push("YearEnergeticUse")
      filtrosBlacklist.push("Yearconsumption")
      filtrosBlacklist.push("YearusedEnergyCost")

      filtrosBlacklist.push("SinceRegistrationTotalGeneration")
      filtrosBlacklist.push("SinceRegistrationselfConsumption")
      filtrosBlacklist.push("SinceRegistrationEnergeticUse")
      filtrosBlacklist.push("SinceRegistrationconsumption")
      filtrosBlacklist.push("SinceRegistrationusedEnergyCost")

      filtrosBlacklist.push("CurrentMonthGivenAwayMoney")
      filtrosBlacklist.push("CurrentMonthselfConsumptionBalance")
      filtrosBlacklist.push("CurrentSolarWalletBalance")      
      filtrosBlacklist.push("TodayenergyRevenue")            
      
    }

    if( jsonObjDashboard.InstallationData.GeneralInfo.ElectricSystemType === "MONOFASICO" ){
        
      filtrosBlacklist.push("GeneralWhInstallationGenerationP1")
      filtrosBlacklist.push("GeneralWhInstallationGenerationP2")
      filtrosBlacklist.push("GeneralWhInstallationGenerationP3")

      filtrosBlacklist.push("GeneralWhInstallationConsumptionP1")
      filtrosBlacklist.push("GeneralWhInstallationConsumptionP2")
      filtrosBlacklist.push("GeneralWhInstallationConsumptionP3")

      filtrosBlacklist.push("GeneralWhInstallationWastedEnergyP1")
      filtrosBlacklist.push("GeneralWhInstallationWastedEnergyP2")
      filtrosBlacklist.push("GeneralWhInstallationWastedEnergyP3")

      filtrosBlacklist.push("GeneralWhInstallationReactiveEnergyP1")
      filtrosBlacklist.push("GeneralWhInstallationReactiveEnergyP2")
      filtrosBlacklist.push("GeneralWhInstallationReactiveEnergyP3")

      filtrosBlacklist.push("GeneralWhInstallationCapacitiveEnergyP1")
      filtrosBlacklist.push("GeneralWhInstallationCapacitiveEnergyP2")
      filtrosBlacklist.push("GeneralWhInstallationCapacitiveEnergyP3")
      
    }

    if( jsonObjDashboard.GeneratorData.GeneratorType === "MONOFASICO" ){
        
      filtrosBlacklist.push("GeneralWhGeneratorGenerationP1")
      filtrosBlacklist.push("GeneralWhGeneratorGenerationP2")
      filtrosBlacklist.push("GeneralWhGeneratorGenerationP3")

    }

    if( (Object.keys(jsonObjDashboard.FVData).length > 0) ){
      if (jsonObjDashboard.FVData.SolarWallet === "false"){              
        filtrosBlacklist.push("CurrentSolarWalletBalance")
      }   
      else{
        filtrosBlacklist.push("CurrentMonthGivenAwayMoney")      
      }

    } 

    if(nombreGrupo==="InstallationData"){ 
      filtrosBlacklist.push("BestBuyPrice")      
      filtrosBlacklist.push("BestSellPrice")      
      filtrosBlacklist.push("MarketAverageBuyPrice")      
      filtrosBlacklist.push("WorstBuyPrice")  
      filtrosBlacklist.push("WorstSellPrice")  
      filtrosBlacklist.push("EnergyBuyPrice")  
      filtrosBlacklist.push("DailyAverageBuyPrice")      
      filtrosBlacklist.push("DailyAverageSellPrice")
    } 

    if(nombreGrupo==="FVData"){ 
      filtrosBlacklist.push("EnergySellPrice")      
      filtrosBlacklist.push("DailyEnergySellPrice")
    }

    if(nombreGrupo==="SelfConsumptionAndSavingsData"){

      if(jsonObjDashboard.InstallationData.GeneralInfo.EnergyBuyPrice === ""){        
        objGrupo["MarketAverageBuyPrice"] = jsonObjDashboard.InstallationData.GeneralInfo.MarketAverageBuyPrice
      }
      else{
        objGrupo["EnergyBuyPrice"] = jsonObjDashboard.InstallationData.GeneralInfo.EnergyBuyPrice        
      }

      objGrupo["DailyAverageBuyPrice"] = jsonObjDashboard.InstallationData.GeneralInfo.DailyAverageBuyPrice        

      try{
        if(jsonObjDashboard.FVData.EnergySellPrice.Value === ""){ // Indexada        
          objGrupo["DailyEnergySellPrice"] = jsonObjDashboard.FVData.DailyEnergySellPrice.Value        
        }
        else{ //Fija        
          objGrupo["EnergySellPrice"] = jsonObjDashboard.FVData.EnergySellPrice.Value            
        }        
        
        objGrupo["DailyAverageSellPrice"] = jsonObjDashboard.InstallationData.GeneralInfo.DailyAverageSellPrice        
      }
      catch(error){}
      
    }

    if(typeof(objGrupo) !== "undefined"){
      if(Object.keys(objGrupo).length > 0){
        for (var x=0; x <Object.keys(objGrupo).length; x++){

          if(!filtrosBlacklist.includes(Object.keys(objGrupo)[x])){ //Si no está en la blacklist procedo
            if(nombreGrupo==="GeneralData"){ objListaFinal.GeneralData.push(Object.keys(objGrupo)[x]) }
            if(nombreGrupo==="MeteoData"){ objListaFinal.MeteoData.push(Object.keys(objGrupo)[x]) }
            if(nombreGrupo==="InstallationData"){                 
              if(objGrupo[Object.keys(objGrupo)[x]].Value !== "N/A"){
                objListaFinal.InstallationData.push(Object.keys(objGrupo)[x]) 
              }                                
            }
            if(nombreGrupo==="FVData"){ 
              if(objGrupo[Object.keys(objGrupo)[x]].Value !== "N/A"){
                if ( (Object.keys(objGrupo)[x] === "FVMaxGenerationEstimation") || (Object.keys(objGrupo)[x] === "FVWastedEnergy") ){
                  if( (InstallationData.EnergyGridConnected === "false") || (InstallationData.GeneralGridSwitch !== "") ){ 
                    objListaFinal.FVData.push(Object.keys(objGrupo)[x])
                  }                    
                  //Sino no los incluyo ya que no hace falta estimar ni se pierde nada al devolverlo a la red.
                }                 
                else{
                  objListaFinal.FVData.push(Object.keys(objGrupo)[x])
                }                  
              }                            
            }
            if(nombreGrupo==="BatteriesData"){ objListaFinal.BatteriesData.push(Object.keys(objGrupo)[x]) }
            if(nombreGrupo==="GeneratorData"){ objListaFinal.GeneratorData.push(Object.keys(objGrupo)[x]) }
            if(nombreGrupo==="CarsData"){ objListaFinal.CarsData.push(Object.keys(objGrupo)[x]) }
            if(nombreGrupo==="SelfConsumptionAndSavingsData"){ objListaFinal.SelfConsumptionAndSavingsData.push(Object.keys(objGrupo)[x]) }
          }
        }
      }
    }      

    objListaFinal.GeneralData.sort()
    objListaFinal.MeteoData.sort()
    objListaFinal.InstallationData.sort()
    objListaFinal.FVData.sort()
    objListaFinal.BatteriesData.sort()
    objListaFinal.GeneratorData.sort()
    objListaFinal.CarsData.sort()
    objListaFinal.SelfConsumptionAndSavingsData.sort()

    return objListaFinal

  }
  
  function setearNinguno(){

    //Deselecciono todos

    var objCheckboxesFiltrado = document.getElementById("filtrosAnalytics").querySelectorAll("input[type='checkbox']")

    for(var x=0; x < objCheckboxesFiltrado.length; x++){        
      document.getElementById(objCheckboxesFiltrado[x].id).checked = false
    }

    //Cierro todas las cajas
    var objDetails = document.getElementById("filtrosAnalytics").querySelectorAll("details")

    for(x=0; x < objDetails.length; x++){        
      document.getElementById(objDetails[x].id).removeAttribute('open');
    }

    analyticsCommonJS.actualizarConteoFiltrosSinRefrescar()      

  }
  
  function gestionarVisibilidadFiltrosAnalytics(event){        
      if ( (document.getElementById("filtrosAnalytics") !== null) && !document.getElementById("filtrosAnalytics").className.includes("hidden") && (event.target.id === "filtrosAnalytics") ){
          document.getElementById("filtrosAnalytics").className = document.getElementById("filtrosAnalytics").className.replaceAll(" hidden", "") + " hidden"
      }
  };  

  function filtrarDatos(){

    var cadenaFiltrado = document.getElementById("textoBuscadorDatosAnalytics").value.toLowerCase()
    var objCheckboxesFiltrado = document.getElementById("listadoFiltrosAnalytics").querySelectorAll("input[type='checkbox']")
    var valorDatoTemp = ""

    //Primero gestiono la visibilidad de las opciones
    for(var x=0; x < objCheckboxesFiltrado.length; x++){        
      valorDatoTemp = document.getElementById(objCheckboxesFiltrado[x].id).getAttribute('searchtext').toLowerCase()
      
      if(valorDatoTemp.includes(cadenaFiltrado)){
        document.getElementById("labelDatos"+objCheckboxesFiltrado[x].id).className = document.getElementById("labelDatos"+objCheckboxesFiltrado[x].id).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById("labelDatos"+objCheckboxesFiltrado[x].id).className = document.getElementById("labelDatos"+objCheckboxesFiltrado[x].id).className.replaceAll(" hidden", "") + " hidden"
      }        
    }

    //Ahora gestiono la visualización de las cajas en función de si tiene resultados visibles o no      
    var objDetails = document.getElementById("listadoFiltrosAnalytics").querySelectorAll("details")
    var idGrupoTemp = ""
    var objCheckboxesGrupoTemp = ""
    var contadorGeneralElementosVisiblesGrupoTemp = 0
    var contadorElementosVisiblesGrupoTemp = 0
    
    for(x=0; x < objDetails.length; x++){        

      idGrupoTemp = objDetails[x].id
      objCheckboxesGrupoTemp = document.getElementById(idGrupoTemp).querySelectorAll("input[type='checkbox']")                
      contadorElementosVisiblesGrupoTemp = 0

      document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className = document.getElementById("botonSeleccionarTodosGrupo"+idGrupoTemp).className.replaceAll(" hidden", "") + " hidden"

      for(var y=0; y < objCheckboxesGrupoTemp.length; y++){             
        if(!document.getElementById("labelDatos"+objCheckboxesGrupoTemp[y].id).className.includes(" hidden")){
          contadorElementosVisiblesGrupoTemp = contadorElementosVisiblesGrupoTemp + 1
          contadorGeneralElementosVisiblesGrupoTemp = contadorGeneralElementosVisiblesGrupoTemp + 1
        }          
      }
      
      if( contadorElementosVisiblesGrupoTemp === 0){
        document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.getElementById(idGrupoTemp).className = document.getElementById(idGrupoTemp).className.replaceAll(" hidden", "")
      }

      document.getElementById(objDetails[x].id).setAttribute('open','open')       

    }   
    
    if(cadenaFiltrado === ""){analyticsCommonJS.resetearBusquedaDatos()}

    if( (objDetails.length > 0) && (contadorGeneralElementosVisiblesGrupoTemp === 0) ){
      document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className = document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className = document.getElementById("divSinResultadosBusquedaFiltrosAnalytics").className.replaceAll(" hidden", "") + " hidden"
    }

  }

  function obtenerDatosFiltradoActual(){

    var objCheckboxesFiltrado = document.getElementById("listadoFiltrosAnalytics").querySelectorAll("input[type='checkbox']")   

    var cadenaFiltradoTemp = ""

    for(var x=0; x < objCheckboxesFiltrado.length; x++){        
      if(document.getElementById(objCheckboxesFiltrado[x].id) !== null){
          if(document.getElementById(objCheckboxesFiltrado[x].id).checked === true){
              cadenaFiltradoTemp += objCheckboxesFiltrado[x].id + "-"
            }
      }            
    }      

    var filtradoActual = cadenaFiltradoTemp.substring(0, cadenaFiltradoTemp.length - 1)      

    return filtradoActual

  }

  function busquedaPersonalizada(){

    var tsFechaDesde = new Date(document.getElementById("fechaDesde").value+"T"+document.getElementById("horaDesde").value).getTime()
    var tsFechaHasta = new Date(document.getElementById("fechaHasta").value+"T"+document.getElementById("horaHasta").value).getTime()

    if(tsFechaDesde <= tsFechaHasta){

      if(!document.getElementById("formularioFechasAnalytics").className.includes(" hidden")){
        document.getElementById("pestañaAnalyticsPersonalizado").checked = true
      }
      
      tsFechaDesde = new Date(document.getElementById("fechaDesde").value).getTime()
      tsFechaHasta = new Date(document.getElementById("fechaHasta").value).getTime()
      var longitudBusqueda = ((tsFechaHasta - tsFechaDesde) / 1000)/60/60/24

      if(longitudBusqueda < 32){        

        var CryptoJS = require("crypto-js");      

        var filtradoActual = obtenerDatosFiltradoActual()

        if(document.getElementById("estadoFavoritoConsulta").checked === true){          
          localStorage.removeItem("lq"+localStorage.getItem("installationId")) //Eliminar más adelante por si se ha dejado basura en el equipo de algún usuario.
          localStorage.setItem("fq"+localStorage.getItem("installationId"),CryptoJS.AES.encrypt(filtradoActual, localStorage.getItem("installationId").substring(0,16)).toString())

          document.getElementById("estadoFavoritoConsulta").checked = false

        }
        
        if(localStorage.getItem("fq"+localStorage.getItem("installationId")) !== null){
          var datosLocalStorage = CryptoJS.AES.decrypt(localStorage.getItem("fq"+localStorage.getItem("installationId")), localStorage.getItem("installationId").substring(0,16)).toString(CryptoJS.enc.Utf8);        

          if(datosLocalStorage === filtradoActual){
            document.getElementById("botonFavoritoAnalytics").className = document.getElementById("botonFavoritoAnalytics").className.replaceAll(" selected", "") + " selected"
          }
          else{
            document.getElementById("botonFavoritoAnalytics").className = document.getElementById("botonFavoritoAnalytics").className.replaceAll(" selected", "")
          }

        }
        
        params.actualizarGrafica("filtros",params.setObjQueryGrafica, ReactGA)

      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("El periodo máximo de búsqueda es de 31 días","negative")
      }
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("La fecha y hora 'Desde' no puede ser posterior a la fecha y hora 'Hasta'","negative")
    }

  }

  function buscarPeriodo(dias){

    var fechaActual = new Date()    

    var añoActual = fechaActual.getFullYear()
    var mesActual = (fechaActual.getMonth()+1)
    var diaActual = fechaActual.getDate()

    var horaActual = fechaActual.getHours()
    var minutosActuales = fechaActual.getMinutes()

    if (mesActual < 10){ mesActual = "0"+mesActual	}
    if (diaActual < 10){ diaActual = "0"+diaActual	}
    
    if (horaActual < 10){ horaActual = "0"+horaActual	}
    if (minutosActuales < 10){ minutosActuales = "0"+minutosActuales	}

    document.getElementById("fechaDesde").value = analyticsCommonJS.calcularNuevaFecha("restar",diaActual,mesActual,añoActual, dias) 
    document.getElementById("fechaHasta").value = añoActual+"-"+mesActual+"-"+diaActual      
    document.getElementById("horaDesde").value = horaActual+":"+minutosActuales
    document.getElementById("horaHasta").value = horaActual+":"+minutosActuales

    busquedaPersonalizada()

  }

  return (    

    <aside id="filtrosAnalytics" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadFiltrosAnalytics}>

        <div className="modal-content">

            <button className="link close" onClick={() => document.getElementById("filtrosAnalytics").className = document.getElementById("filtrosAnalytics").className.replaceAll(" hidden", "") + " hidden" }><span className="material-icon">highlight_off</span></button>
            <div className="page">
                
                <header>
                  <h1 id="tituloDetalleWidgetAnalytics" className="headline-02 fill"> </h1>
                  <button id="botonReiniciarFiltros" className="link size-s uppercase" onClick={() =>  setearNinguno()}><span className="material-icon">playlist_remove</span>Desmarcar todo</button>
                </header>

                <div className="vertical gap-02">
                  <button className="button primary full-width" type="button" onClick={ () => busquedaPersonalizada() }>Consultar</button>
                  <fieldset id="fieldsetEstadoFavoritoConsulta" className="check multiple toggle green full-bleed">
                    <input type="checkbox" id="estadoFavoritoConsulta" name="estadoRegla"/>
                    <label className="icon-wrapper" htmlFor="estadoFavoritoConsulta" style={{paddingBottom: "0px"}}>Guardar como datos favoritos</label>
                  </fieldset>
                </div>
                
                <div id="divMensajeErrorFiltros" className="message error left hidden">
                  <h1 className="title"><span className="material-icon">error</span>Atención</h1>
                  <p>Debes seleccionar al menos un dato para poder actualizar la gráfica.</p>
                </div>

                <fieldset id="formularioFechasAnalytics" className="vertical gap-02">

                  <fieldset className="horizontal gap-04">
                    <button className="button tertiary full-width" type="button" onClick={ () => buscarPeriodo(7) }>Últimos 7 días</button>
                    <button className="button tertiary full-width" type="button" onClick={ () => buscarPeriodo(15) }>Últimos 15 días</button>
                    <button className="button tertiary full-width" type="button" onClick={ () => buscarPeriodo(30) }>Últimos 30 días</button>
                  </fieldset>

                  <fieldset className="horizontal gap-04">
                      
                    <div className="col"> 
                      <fieldset className="date">
                        <label htmlFor="labelFechaDesde"><b>Fecha desde</b></label>	
                        <fieldset className="icon-wrapper">
                          <input type="date" id="fechaDesde" name="fechaDesde" max={fechaActual}/>
                        </fieldset>
                      </fieldset>
                    </div>
                    
                    <div className="col">
                      <fieldset className="time">
                        <label htmlFor="labelHoraDesde"><b>Hora desde</b></label>		
                        <div className="icon-wrapper">
                          <input type="time" id="horaDesde" name="horaDesde" min="00:00" max="23:59" />
                        </div>
                      </fieldset>
                    </div>
                    
                  </fieldset>

                  <fieldset className="horizontal gap-04">
                      
                    <div className="col">
                      <fieldset className="date">
                        <label htmlFor="labelFechaHasta"><b>Fecha hasta</b></label>		
                        <fieldset className="icon-wrapper">
                          <input type="date" id="fechaHasta" name="fechaHasta" max={fechaActual}/>		
                        </fieldset>
                      </fieldset>
                    </div>

                    <div className="col">
                      <fieldset className="time">
                        <label htmlFor="labelHoraHasta"><b>Hora hasta</b></label>		
                        <div className="icon-wrapper">
                          <input type="time" id="horaHasta" name="horaHasta" min="00:00" max="23:59" />
                        </div>
                      </fieldset>
                    </div>
                    
                  </fieldset>
                  
                </fieldset>

                <div className="vertical gap-02">                  

                  <fieldset id="fieldsetTextoBuscadorDatosAnalytics" className="search automatic">
                    <input type="search" id="textoBuscadorDatosAnalytics" spellCheck="false" autoComplete="off" placeholder="Buscar dato..." onKeyUp={() => filtrarDatos()}/>
                    <span className="material-icon icon-wrapper" onClick={() => analyticsCommonJS.resetearBusquedaDatos()}></span>
                  </fieldset>

                  <div id="listadoFiltrosAnalytics" className="vertical gap-02">
                    <FilterGroup groupId="GeneralData" groupName="Información general" objGroup={objGroupsData.GeneralData}/>
                    <FilterGroup groupId="MeteoData" groupName="Meteorología" objGroup={objGroupsData.MeteoData}/>
                    <FilterGroup groupId="InstallationData" groupName="Instalación" objGroup={objGroupsData.InstallationData}/>
                    <FilterGroup groupId="FVData" groupName="Paneles solares" objGroup={objGroupsData.FVData}/>
                    <FilterGroup groupId="BatteriesData" groupName="Baterías" objGroup={objGroupsData.BatteriesData}/>
                    <FilterGroup groupId="GeneratorData" groupName="Grupo electrógeno" objGroup={objGroupsData.GeneratorData}/>
                    <FilterGroup groupId="CarsData" groupName="Coche" objGroup={objGroupsData.CarsData}/>
                    <FilterGroup groupId="SelfConsumptionAndSavingsData" groupName="Economía" objGroup={objGroupsData.SelfConsumptionAndSavingsData}/>
                  </div>

                  <div id="divSinResultadosBusquedaFiltrosAnalytics" className="message medium empty hidden">
                    <picture>
                      <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                      <img src={imgNoResultsDark} alt=" "/>
                    </picture>
                    <h1 className="title">No existen resultados para esta búsqueda</h1>                  
                  </div>

                </div>

            </div>
        </div>
    </aside>

  )
}

export default AnalyticsFilters